import React from 'react';

const IntroBanner = () => {
  return (
    <div className="main-banner" id="top">
      <video autoPlay muted loop id="bg-video">
        <source src="/assets/images/capuccino.mp4" type="video/mp4" />
      </video>

      <div className="video-overlay header-text">
        <div className="caption">
          <h6>Welcome to the Mobile Coffee bar</h6>
          <h2>Taste the love at our <em>Great Service</em></h2>
          <div className="main-button">
            <a href="/bookings">Book us Today!</a>
          </div>
        </div>
      </div>
    </div>
  )
};

export default IntroBanner;
